import { createStore } from 'stimulus-store';

/**
 * Store to track whether devices are currently being loaded.
 * 
 * States:
 * - true: Devices are being fetched from the server
 * - false: Devices have finished loading (or haven't started)
 * 
 * This store works in conjunction with allDevicesStore to distinguish between:
 * - "Not loaded yet" (loading = false, devices = [])
 * - "Currently loading" (loading = true, devices = [])
 * - "Loaded but empty" (loading = false, devices = [])
 * - "Loaded with data" (loading = false, devices = [...])
 */
export const devicesLoadingStore = createStore({
    name: 'devicesLoadingStore',
    type: Boolean,
    initialValue: false
});
